import { useMemo } from "react";
import RoutesService from "./RoutesService";

export default function useRouteService() {
  return useMemo(() => new RoutesService(), []);
}
